import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 60000,
});

export const endpoints = {
    mosCatalog: () => api.get("/mos/catalog"),
    mosLookup: (payload) => api.post("/mos/lookup", payload),
    benefitsSnapshot: () => api.get("/benefits/snapshot"),
    benefitsLog: (payload) => api.post("/benefits/log", payload),
    recruiterScript: (payload) => api.post("/recruiter/script", payload),
    transitionCountdown: () => api.get("/transition/countdown"),
    transitionLatest: () => api.get("/transition/plan/latest"),
    transitionCreate: (payload) => api.post("/transition/plan", payload),
    strikesToday: () => api.get("/sovereign/strikes/today"),
    strikeUpdate: (id, completed) => api.patch(`/sovereign/strikes/${id}`, { completed }),
    strikesReset: () => api.post("/sovereign/strikes/reset"),
    legacyPulse: () => api.get("/legacy/pulse"),
    legacyAdd: (payload) => api.post("/legacy/pulse", payload),
};
